import AuthForm, {STATE_LOGIN} from 'components/AuthForm';
import React from 'react';
import {Card, Col, FormGroup, Row} from 'reactstrap';
import queryString from "query-string";
import BaseComponent from "../components/BaseComponent";
import {GoogleReCaptchaProvider, useGoogleReCaptcha} from "react-google-recaptcha-v3";
import {getData, storeData} from "../utils/StorageUtil";
import Endpoint from "enqc-utilities/src/api/Endpoint";
import Global from "enqc-utilities/src/utils/Global";

class AuthPage extends BaseComponent {

    constructor(props) {
        super(props);
        let state = this.state
        state.recaptchaSiteKey = ""
        state.message = queryString.parse(this.props.query).message
        this.setState(state)
    }


    handleAuthState = authState => {
        if (authState === STATE_LOGIN) {
            this.props.history.push('/login');
        } else {
            this.props.history.push('/signup');
        }
    };

    handleLogoClick = () => {
        this.props.history.push('/');
    };

    componentDidMount() {
        super.componentDidMount();
        this.fetchRecaptchaSiteKey()
        // let configuration = getData(Global.CONFIGURATION);
        // this.setState({configuration})
    }

    fetchRecaptchaSiteKey = () => {
        this.get(Endpoint.API.GOOGLE_RECAPTCHA_SITE_KEY, {
            params:{}
        }, null, response=>{
            if(response.code === 200){
                let recaptchaSiteKey = response.data
                storeData(Global.GOOGLE_RECAPTCHA_SITE_KEY, recaptchaSiteKey)
                console.log("@@@@@@@@@@@@@@@@@@ "+recaptchaSiteKey)
                this.setState({
                    recaptchaSiteKey
                }, () => {
                    this.forceUpdate()
                })
            }
        }, true, true);
    }


    render() {

        let {message, recaptchaSiteKey} = this.state
        if(!recaptchaSiteKey){
            recaptchaSiteKey = getData(Global.GOOGLE_RECAPTCHA_SITE_KEY)
        }
        if (!recaptchaSiteKey) {
            return <div>Loading...</div>;
        }

        return (
            <Row
                style={{
                    height: '100vh',
                    justifyContent: 'center',
                    alignItems: 'center',
                }}>
                <Col md={6} lg={4}>
                    <Card body>
                        <GoogleReCaptchaProvider
                            reCaptchaKey={recaptchaSiteKey}
                            scriptProps={{
                                async: true,
                                defer: true,
                                appendTo: "head"
                            }}>
                            <AuthFormWithCaptcha
                                authState={this.props.authState}
                                onChangeAuthState={this.handleAuthState}
                                onLogoClick={this.handleLogoClick}
                                message={message}
                            />
                        </GoogleReCaptchaProvider>
                    </Card>
                </Col>
            </Row>
        );
    }
}

const AuthFormWithCaptcha = (props) => {
    const { executeRecaptcha } = useGoogleReCaptcha();
    return <AuthForm {...props} executeRecaptcha={executeRecaptcha} />;
};

export default Object.assign(AuthPage, {ENDPOINT: "/login"})
